const initialState = {};
import * as Constants from '../constants';


export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
   case Constants.FETCH_DELIVERED_MEDICINES_START:
      return Object.assign({}, state, {
        data: action.data,
        action: action,
        loading: true
      });
    case Constants.FETCH_DELIVERED_MEDICINES_SUCCESS:
      return Object.assign({}, state, {
        data: action.data,
        action: action,
        loading: false
      });
    case Constants.FETCH_DELIVERED_MEDICINES_FAILURE:
      return Object.assign({}, state, {
        data: action.data,
        action: action,
        loading: false
      });
    default:
     return {...state}  
  }
}
